import script from "./RequestDetailsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestDetailsModal.vue?vue&type=script&setup=true&lang=js"

import "./RequestDetailsModal.vue?vue&type=style&index=0&id=71869cb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71869cb2"]])

export default __exports__